import React from 'react'
import PropTypes from 'prop-types'

import FacebookWallShareButton from './FacebookWallShareButton';
import request from 'superagent';


export default class ShareOrderFacebookButton extends React.Component {
    static propTypes = {
        onShareApiUrl: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            isShared: this.props.initialIsShared
        };

        this.handleOnShareSuccess = this.handleOnShareSuccess.bind(this);
    }

    handleOnShareSuccess() {
        if (window.ga) {
            ga('send', 'event', 'FBOrderShared', 'fb-order-shared');
        }

        request.post(this.props.onShareApiUrl)
            .set('Accept', 'application/json')
            .end((error, res) => {
                this.setState({
                    isShared: true
                });
            });
    }

    renderAlreadyShared() {
        return (
            <div className="alert alert-info facebook-share-order--success">
                Grazie per aver condiviso il tuo ordine con i tuoi amici!<br/>Ti abbiamo regalato 1 Punto FR!
            </div>
        );
    }

    render() {
        return (
            this.state.isShared ? this.renderAlreadyShared() : <FacebookWallShareButton {...this.props}
                                                                                        onShareSuccess={this.handleOnShareSuccess}/>
        )
    }
}
